import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';



// import Iconify from 'src/components/iconify';

import { NAV, HEADER } from './config-layout';
import AccountPopover from './common/account-popover';
import { useResponsive } from '../../hooks/use-responsive';
import Iconify from '../../components/iconify/iconify';
import { bgBlur } from '../../theme/css';


// ----------------------------------------------------------------------

export default function Header({ onOpenNav }) {
  const theme = useTheme();

  const lgUp = useResponsive('up', 'lg');

  const renderContent = (
    <>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box display={{ xs: "flex", md: "none" }}>

          <AccountPopover />
        </Box>
      </Stack>
      <Box sx={{ flexGrow: 1 }} />

      {!lgUp && (
        <IconButton onClick={onOpenNav} sx={{ ml: "auto", color: "black" }}>
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>
      )}
      <Box display={{ xs: "none", md: "flex" }}>

        <AccountPopover />
      </Box>



    </>
  );

  return (
    <AppBar
      sx={{
        boxShadow: 'none',
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        backgroundColor: "white",
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.WIDTH + 1}px)`,
          height: HEADER.H_DESKTOP,
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
          color: "black"
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  onOpenNav: PropTypes.func,
};
